import { render, staticRenderFns } from "./Knowledge.vue?vue&type=template&id=364efb46&"
import script from "./Knowledge.vue?vue&type=script&lang=js&"
export * from "./Knowledge.vue?vue&type=script&lang=js&"
import style0 from "./Knowledge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports